<div
  class="checkbox-field"
  [class.disabled]="disabled"
  (click)="toggleCheckbox($event)"
>
  <input
    type="checkbox"
    [attr.data-e2e-id]="e2eId"
    [formControl]="fieldControl"
    tabindex="0"
    (focus)="onFocus()"
    (blur)="onBlur()"
  />

  <i2g-icon
    *ngIf="icon"
    class="icon checkbox-icon"
    [icon]="icon"
    (click)="clickIcon.emit()"
  >
  </i2g-icon>

  <div
    class="checkbox"
    [class.checked]="fieldControl?.value"
    [class.focus]="isFocused"
    [class.disabled]="disabled"
  >
    <i2g-icon name="checkmark-sharp" size="custom"></i2g-icon>
  </div>

  <label class="label" *ngIf="label" [class.disabled]="fieldControl?.disabled">
    {{ label }}
  </label>

  <label
    class="label"
    *ngIf="labelInnerHtml"
    [class.disabled]="fieldControl?.disabled"
    [innerHTML]="labelInnerHtml"
  >
    {{ label }}
  </label>
</div>

<i2g-error-message
  class="error-message"
  [dirty]="fieldControl.dirty"
  [invalid]="fieldControl.invalid"
  [errorMessage]="errorMessage"
>
</i2g-error-message>

<p *ngIf="description" class="description">
  {{ description }}
</p>
